import { render, staticRenderFns } from "./SdkSmallInformation.vue?vue&type=template&id=092858fe&"
import script from "./SdkSmallInformation.vue?vue&type=script&lang=js&"
export * from "./SdkSmallInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports